module.exports = __webpack_public_path__ + "static/media/profile-placeholder.a20c04db.jpg";